// Shared by the onboarding screens (OnboardingScreen, GetVerifiedScreen).

export const glassCard = {
  background: 'rgba(255, 255, 255, 0.12)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: '1px solid rgba(255, 255, 255, 0.18)',
};

export const bgStyle = {
  background: `
    radial-gradient(ellipse at 20% 50%, var(--gradient-warm-1) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 20%, var(--gradient-warm-2) 0%, transparent 40%),
    radial-gradient(ellipse at 50% 80%, var(--gradient-warm-3) 0%, transparent 45%),
    radial-gradient(ellipse at 70% 60%, var(--gradient-warm-4) 0%, transparent 50%),
    var(--gradient-base)
  `,
  backgroundSize: '200% 200%',
  animation: 'splashGradientShift 12s ease infinite',
};
